/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { RESERVE_TYPES } from 'constants'

export const UPGRADE_EFFECT_POPOVER_ID = 'upgrade_effect_popover'

export const RESERVE_TYPE_MESSAGES = {
    [RESERVE_TYPES.BATTLE_PAYMENTS]: (
        <FormattedMessage
            id='upgrade_effect_popover.reserve_types.battle_payments'
            defaultMessage='Дополнительные кредиты'
        />
    ),
    [RESERVE_TYPES.MILITARY_MANEUVERS]: (
        <FormattedMessage
            id='upgrade_effect_popover.reserve_types.military_maneuvers'
            defaultMessage='Дополнительный свободный опыт'
        />
    ),
    [RESERVE_TYPES.TACTICAL_TRAINING]: (
        <FormattedMessage
            id='upgrade_effect_popover.reserve_types.tactical_training'
            defaultMessage='Дополнительный боевой опыт'
        />
    ),
    [RESERVE_TYPES.ADDITIONAL_BRIEFING]: (
        <FormattedMessage
            id='upgrade_effect_popover.reserve_types.additional_briefing'
            defaultMessage='Дополнительный опыт экипажа'
        />
    ),
    [RESERVE_TYPES.AIRSTRIKE]: (
        <FormattedMessage
            id='upgrade_effect_popover.reserve_types.airstrike'
            defaultMessage='Дополнительный промресурс на 1 бой'
        />
    ),
    [RESERVE_TYPES.ARTILLERY_STRIKE]: (
        <FormattedMessage
            id='upgrade_effect_popover.reserve_types.artillery_strike'
            defaultMessage='Артобстрел в Вылазках и при Наступлениях на 1 бой'
        />
    ),
    [RESERVE_TYPES.HIGH_CAPACITY_TRANSPORT]: (
        <FormattedMessage
            id='upgrade_effect_popover.reserve_types.high_capacity_transport'
            defaultMessage='Дополнительный промресурс на 1 бой'
        />
    ),
    [RESERVE_TYPES.REQUISITION]: (
        <FormattedMessage
            id='upgrade_effect_popover.reserve_types.requisition'
            defaultMessage='Дополнительный промресурс на 1 Наступление'
        />
    ),
    [RESERVE_TYPES.INSPIRATION]: (
        <FormattedMessage
            id='upgrade_effect_popover.reserve_types.inspiration'
            defaultMessage='Воодушевление в Вылазках и при Наступлениях на 1 бой'
        />
    ),
}

export const RESERVE_LEVEL_HEADER = (
    <FormattedMessage
        id='upgrade_effect_popover.reserve_level_header'
        defaultMessage='Уровень резерва'
    />
)

export const UPGRADE_COST_HEADER = (isLineBreakEnabled) => (
    <FormattedMessage
        id='upgrade_effect_popover.upgrade_cost_header'
        defaultMessage='Стоимость{lineBreak}модернизации'
        values={{
            lineBreak: isLineBreakEnabled ? <br /> : ' ',
        }}
    />
)

export const PERMISSIONS_REQUIRED_MESSAGE = (
    <FormattedMessage
        id='upgrade_effect_popover.permissions_required_message'
        defaultMessage='Модернизировать строение могут командующий и его заместители'
    />
)

export const UPGRADE_DESCRIPTION = (reserve) => (
    <FormattedMessage
        id='upgrade_effect_popover.upgrade.description'
        defaultMessage='После модернизации станет доступна подготовка резерва «{reserve}» следующего уровня.'
        values={{
            reserve,
        }}
    />
)

export const MAX_LEVEL_MESSAGE = (
    <FormattedMessage
        id='upgrade_effect_popover.max_level_message'
        defaultMessage='Строение модернизировано до максимального уровня'
    />
)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/UpgradeEffectContent/constants.jsx